
// form submit logic in custom-form.js


$('.js-copy-code').click(function(){
    let code = $('.js-code').data('value')
    copyText(code)
    showCopiedPopup()
})

$('.js-copy-url').click(function(){
    let code = $(this).closest('.js-copy-row').find('.js-url').data('value')
    copyText(code)
    showCopiedPopup()
})


function copyText(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
}


function showCopiedPopup() {
    console.log('show')
    const popup = $('.js-copied-success-popup');
    popup.fadeIn();
    setTimeout(() => {
        popup.fadeOut()
    }, 1500);
}
